// extracted by mini-css-extract-plugin
module.exports = {"paragraph-detail":"styles_paragraph-detail__FMowl","nr-container":"styles_nr-container__iryqS","image":"styles_image___ZRdb","h3":"styles_h3___OQq_","h4":"styles_h4__zEHeM"};